import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'h1', 'h2', 'h3', 'p', 'br', 'ul', 'ol', 'li', 'strong', 'em', 'div', 'span', 'section'
];

const ALLOWED_CLASSES = [
  'plan-content',
  'day-header',
  'task-label',
  'hashtags',
  'section'
];

const ALLOWED_STYLES: string[] = [];

export const sanitizeHtml = (html: string): string => {
  // Configure DOMPurify
  const config = {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['class'],
    ALLOWED_CLASSES: {
      '*': ALLOWED_CLASSES
    },
    ALLOWED_STYLES,
    KEEP_CONTENT: true,
    RETURN_DOM_FRAGMENT: false,
    RETURN_DOM: false,
    FORCE_BODY: false,
    SANITIZE_DOM: true
  };

  // Clean and sanitize HTML
  const clean = DOMPurify.sanitize(html, config);

  // Ensure proper class preservation
  const parser = new DOMParser();
  const doc = parser.parseFromString(clean, 'text/html');
  
  // Re-apply classes and ensure proper structure
  doc.querySelectorAll('*').forEach(element => {
    const tagName = element.tagName.toLowerCase();

    // Add base plan-content class to root div if not present
    if (tagName === 'div' && !element.className.includes('plan-content')) {
      element.classList.add('plan-content');
    }

    // Group content into sections for better spacing
    if (element.classList.contains('day-header')) {
      const section = doc.createElement('section');
      section.className = 'section';
      element.parentNode?.insertBefore(section, element);
      let next = element;
      while (next && !next.classList.contains('day-header')) {
        const current = next;
        next = next.nextElementSibling as Element;
        section.appendChild(current);
      }
    }

    // Remove any inline styles
    element.removeAttribute('style');

    // Ensure proper element nesting
    if (tagName === 'li' && element.parentElement?.tagName.toLowerCase() !== 'ul' && 
        element.parentElement?.tagName.toLowerCase() !== 'ol') {
      const ul = doc.createElement('ul');
      element.parentNode?.insertBefore(ul, element);
      ul.appendChild(element);
    }
  });

  return doc.body.innerHTML;
};